let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1665738498872x652450591113740300',
        data: '2023, February 22',
    },
    {
        id: 2,
        trackTitle: "Entry-level",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Entry-level',
        trackLink: 'https://geekle.us/ticketfree/1665738407640x556627548543647740',
        data: '2023, February 21',
    },
];

export default PackagesItem;
